var sizeToTitleFontSize = {
  '2xl': 'huge',
  xl: 'huge',
  lg: 'large',
  md: 'medium',
  sm: 'small',
  xs: 'small',
  xxs: 'small'
};
var sizeToSubtitleFontSize = {
  '2xl': 'small',
  xl: 'small',
  lg: 'tiny',
  md: 'tiny',
  sm: 'tiny',
  xs: 'tiny',
  xxs: 'tiny'
};

export { sizeToSubtitleFontSize, sizeToTitleFontSize };
